import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { ReactNode } from "react";
import { useCountryStore } from "../stores/useCountry";
import { useLoadStore } from "../stores/useLoad";
import i18n from "../translate/i18n";

export function LanguageLoader({ children }: { children: ReactNode }) {
  const { loading, setLoading } = useLoadStore();
  const setCountry = useCountryStore((state) => state.setCountry);
  const country = useCountryStore((state) => state.country);

  useEffect(() => {
    setLoading(true);
    const browserLang = navigator.language.toLowerCase();

    if (browserLang === "es-co") {
      setCountry("CO");
    } else if (browserLang === "es-pe") {
      setCountry("PE");
    } else if (browserLang === "es-ec") {
      setCountry("EC");
    } else {
      setCountry("BR");
    }
  }, []);

  useEffect(() => {
    if (country) {
      const language = country === "BR" ? "pt" : "es";
      i18n.changeLanguage(language);
      setLoading(false);
    }
  }, [country]);

  if (loading) {
    return <CircularProgress />;
  }

  return <>{children}</>;
}
